export { default as StructureAuth } from './structure/auth'
export { default as Layout } from './structure/layout'
export { default as StructurePage } from './structure/page'

